export const FETCH_PACKETS_API =
	'/products/packet?platform=BROWSER&order=order&orderDir=asc&subtype=:subtype&show_included_packets=true';

export const FETCH_SUBSCRIBER_SUBSCRIPTION = '/packetsSubscription/details';

export const FETCH_CONFIGURATOR_PRICE = '/packetsSubscription/calculatePrice';

export const FETCH_PRICES_FOR_PACKETS =
	'/packetsSubscription/calculatePriceAnonymous';

export const FETCH_CONFIGURATOR_PACKETS_DETAILS =
	'/products/:uuid/prices/:period';

export const FETCH_CONFIGURATOR_CREATE = '/packetsSubscription/create';

export const FETCH_CONFIGURATOR_UPDATE = '/packetsSubscription/update';

export const FETCH_CONFIGURATOR_ADD_ADDITIONAL =
	'/packetsSubscription/addAdditionalPackets';

export const FETCH_CONFIGURATOR_AGREEMENT_ACCEPT =
	'/subscriber/agreements/accept';

export const FETCH_CONFIGURATOR_INVOICE = '/invoice/info';

export const SEND_OFFER_EMAIL = '/packetsSubscription/sendPrePaymentMail';

export const FETCH_CONFIGURATOR_SETTINGS = '/packetsSubscription/settings';

// Query keys
export const FETCH_DETAILS_QUERY_KEY = 'FETCH_DETAILS_QUERY_KEY';
